var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Resources } from '@shared/localizations/Resources';
import { ScreensNames } from '../UtilsClasses/FactoryConstants';
import { TerceraWindowBase } from './TerceraWindowBase';
import WebhookCreatedScreenTemplate from '@front/templates/WebhookCreatedScreenTemplate.html';
import { BrandingUtils } from '@shared/commons/UtilsClasses/BrandingUtils';
import { ErrorInformationStorage } from '@shared/commons/ErrorInformationStorage';
import { ButtonType } from '@components/webdesktop/elements/Button/ButtonType';
export class WebhookCreatedScreen extends TerceraWindowBase {
    constructor() {
        super();
    }
    getType() {
        return ScreensNames.WebhookCreatedScreen;
    }
    oninit() {
        super.oninit();
        this.observe('webhook', (newValue) => {
            this.set('nameValue', newValue.name);
            this.set('apiKeyValue', newValue.apiKey);
            this.set('secretKeyValue', newValue.secretKey);
            this.set('webhookUrlValue', BrandingUtils.CreateWebhookURL(newValue.apiKey, newValue.secretKey));
        }, { init: false });
    }
    oncomplete() {
        super.oncomplete();
        this.localize();
        this.center();
    }
    localize() {
        super.localize();
        this.set({
            header: Resources.getResource('screen.WebhookCreatedScreen'),
            nameLabel: Resources.getResource('screen.WebhookCreatedScreen.nameLabel'),
            apiKeyLabel: Resources.getResource('screen.WebhookCreatedScreen.apiKeyLabel'),
            secretKeyLabel: Resources.getResource('screen.WebhookCreatedScreen.secretKeyLabel'),
            webhookUrlLabel: Resources.getResource('screen.WebhookCreatedScreen.webhookUrlLabel'),
            showKeyTooltip: Resources.getResource('screen.WebhookCreatedScreen.showKeyTooltip'),
            hideKeyTooltip: Resources.getResource('screen.WebhookCreatedScreen.hideKeyTooltip'),
            copyButtonTooltip: Resources.getResource('general.CopyToClipboard'),
            warningLabel: Resources.getResource('screen.WebhookCreatedScreen.warningLabel'),
            okButtonText: Resources.getResource('general.messageBox.ok'),
            viewApiDocsText: Resources.getResource('screen.Webhooks.viewApiDocs')
        });
    }
    onApiKeyValueToggleVisibility() {
        this.set('apiKeyValueIsVisible', !this.get('apiKeyValueIsVisible'));
    }
    onSecretKeyValueToggleVisibility() {
        this.set('secretKeyValueIsVisible', !this.get('secretKeyValueIsVisible'));
    }
    onWebhookUrlToggleVisibility() {
        this.set('webhookUrlIsVisible', !this.get('webhookUrlIsVisible'));
    }
    onCopyToClipboard(value) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield navigator.clipboard.writeText(value);
            }
            catch (error) {
                ErrorInformationStorage.GetException(error);
            }
        });
    }
    onOkButtonClicked() {
        this.close();
    }
}
TerceraWindowBase.extendWith(WebhookCreatedScreen, {
    data: function () {
        return {
            movable: true,
            resizable: false,
            showFooter: false,
            focused: true,
            showModalMask: true,
            width: 490,
            nameLabel: '',
            nameValue: '',
            apiKeyLabel: '',
            apiKeyValue: '',
            apiKeyValueIsVisible: false,
            secretKeyLabel: '',
            secretKeyValue: '',
            secretKeyValueIsVisible: false,
            webhookUrlLabel: '',
            webhookUrlValue: '',
            webhookBrandingUrl: BrandingUtils.GetBrandingWebhookURL(),
            webhookUrlIsVisible: false,
            showKeyTooltip: '',
            hideKeyTooltip: '',
            copyButtonTooltip: '',
            warningLabel: '',
            okButtonType: ButtonType.Primary,
            okButtonText: '',
            viewApiDocsText: '',
            viewApiDocsUrl: BrandingUtils.GetBrandingWebhookHelpURL()
        };
    },
    partials: { bodyPartial: WebhookCreatedScreenTemplate }
});
